module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Battery-half-605d6735ab028b014c883a58b4b4eeec.svg";